<template>
  <section>
    <SharedPageHeaderTitle :title="t('pages.features.shop.headerTitle')" />

    <div class="base-container-first shop__wrapper">
      <SharedPageSectionCard :card="SECTION_CARD" />

      <ul class="shop__cards three-cards">
        <li
          v-for="(card, cardIndex) in CARDS"
          :key="cardIndex"
        >
          <SharedPageCard
            isWhite
            :card
          />
        </li>
      </ul>

      <SharedPageBusiness :business-list="BUSINESSES" />

      <ul class="shop__cards">
        <li
          v-for="(setting, settingIndex) in SETTINGS"
          :key="settingIndex"
        >
          <SharedPageCard
            isWhite
            :card="setting"
          />
        </li>
      </ul>
    </div>
  </section>

  <ContactOrderForm
    :description="t('pages.features.shop.managerDescription')"
    :title="t('pages.features.shop.questionsTitle')"
  />
</template>

<script setup lang="ts">
const { t, locale } = useI18n();

const CARDS = computed(() => [
  {
    description: t("pages.features.shop.cards.catalog.description"),
    image: "shop-card-1",
    title: t("pages.features.shop.cards.catalog.title"),
  },
  {
    description: t("pages.features.shop.cards.products.description"),
    image: "shop-card-2",
    title: t("pages.features.shop.cards.products.title"),
  },
  {
    description: t("pages.features.shop.cards.orders.description"),
    image: "shop-card-3",
    title: t("pages.features.shop.cards.orders.title"),
  },
]);

const SECTION_CARD = computed(() => ({
  description: t("pages.features.shop.sectionCard.description"),
  href: "https://t.me/RunningFiveBot",
  image: "shop-section-card",
  title: t("pages.features.shop.sectionCard.title"),
}));

const BUSINESSES = computed(() => [
  t("pages.features.shop.businesses.clothing"),
  t("pages.features.shop.businesses.cosmetics"),
  t("pages.features.shop.businesses.autoparts"),
  t("pages.features.shop.businesses.dishes"),
  t("pages.features.shop.businesses.yourBusiness"),
]);

const SETTINGS = computed(() => [
  {
    description: t("pages.features.shop.cards.deliveryTypes.description"),
    image: "shop-card-4",
    title: t("pages.features.shop.cards.deliveryTypes.title"),
  },
  {
    description: t("pages.features.shop.cards.clientNotifications.description"),
    image: "shop-card-5",
    title: t("pages.features.shop.cards.clientNotifications.title"),
  },
]);

useSeoMeta({
  title: t("pages.features.shop.seo.title"),
});
</script>

<style scoped>
.shop__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 80px;
  margin: 0 auto 80px;
  padding: 0 24px;
}

@media (--desktop) {
  .shop__wrapper {
    row-gap: 120px;
    margin-bottom: 120px;
  }
}

.shop__cards {
  display: grid;
  row-gap: 16px;
}

@media (--desktop) {
  .shop__cards {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
  }
}

@media (--desktop) {
  .shop__cards.three-cards {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
